var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleList"},[_c('p',{staticClass:"listSize"},[_vm._v("\n    "+_vm._s(_vm.$t('iDalgoListEdit.title.listSize', { listSize: _vm.listSize })))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.template.name))]),_vm._v(" "),_c('p',{staticClass:"counterResume",domProps:{"innerHTML":_vm._s(_vm.listCounterHtml)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f4ec2a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/iDalgo-List-Title.vue
// module id = null
// module chunks = 